import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import { fetchShoppings } from '@/actions/shopping';
import PageHeader from '@/components/common/PageHeader';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import ShoppingMenuTabContainer from '@/containers/shoppings/ShoppingMenuTabContainer';
import styles from 'styles/jss/original/pages/shoppings';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const ShoppingsPage: NextPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.shopping.title}
          description={meta.shopping.description}
          image={meta.shopping.image}
          url={meta.shopping.url}
        />
        <PageHeader type='shopping' />
        <div className={classes.main}>
          <ShoppingMenuTabContainer />
        </div>
        <BottomBanner type='shopping' />
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await (store.dispatch as AppDispatch)(fetchShoppings());
  return {};
});

export default ShoppingsPage;
